import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

import Tile from '../../bits/Tile.jsx';
import TileActionRow from '../../bits/TileActionRow.jsx';
import AddToggleButton from '../../bits/AddToggleButton.jsx';
import Switch from '../../bits/Switch.jsx';
import Button from '../../bits/Button.jsx';

import '../../../../stylesheets/components/geofence_editor.scss';

class GeofenceEditorPanel extends Component {
  state = {
    loading: false,
    name: this.props.geofence.name || '',
    onEnter: this.props.geofence.persisted ? this.props.geofence.alertOnEnter : true,
    onExit: this.props.geofence.persisted ? this.props.geofence.alertOnExit : true,
    availableDevices: [],
    selectedDevices: [],
  };

  componentDidMount() {
  }

  handleSwitchChange = (event) => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  }

  handleDeviceToggle = (deviceId) => {
    this.setState((state) => {
      let { selectedDevices } = state;
      if (selectedDevices.includes(deviceId)) {
        selectedDevices = selectedDevices.filter(e => e !== deviceId);
      } else {
        selectedDevices = [...selectedDevices, deviceId];
      }
      return { selectedDevices };
    });
  }

  isDeviceSelected = device => this.state.selectedDevices.includes(device.id);

  renderDeviceRows() {
    return this.state.availableDevices.map(device => (
      <TileActionRow key={device.id} label={device.name} action={
        <AddToggleButton
          name={device.id}
          onClick={this.handleDeviceToggle}
          checked={this.isDeviceSelected(device)} />
      } />
    ));
  }

  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  }

  handleSubmit = () => {
    const { onSave } = this.props;

    this.setState({ loading: true });

    onSave({
      name: this.state.name,
      alertOnEnter: this.state.onEnter,
      alertOnExit: this.state.onExit,
    }).catch((e) => {
      this.setState({ loading: false });
      console.error(e);
    })
  }

  handleDelete = () => {
    const { onDelete } = this.props;

    this.setState({ loading: true });

    onDelete().catch((e) => {
      this.setState({ loading: false });
      console.error(e);
    });
  }

  isGeofencePersisted = () => {
    const { geofence } = this.props;
    return geofence && geofence.persisted;
  }

  render() {
    return (
      <div>
        <div className="deviceNameField">
          <TextField id="standard-basic"
            label="Name" fullWidth
            variant="outlined"
            value={this.state.name}
            onChange={this.handleNameChange} />
        </div>
        <Tile
          title="Alerts"
          subtitle="Receive notifications when your tracker enters or exits your geofence.">
          <TileActionRow label="On Enter" action={
            <Switch
              name="onEnter"
              className="up-8"
              edge="end"
              onChange={this.handleSwitchChange}
              checked={this.state.onEnter}
              inputProps={{ 'aria-labelledby': 'switch-list-label-bluetooth' }}
            />} />
          <TileActionRow label="On Exit" action={
            <Switch
              name="onExit"
              className="up-8"
              edge="end"
              onChange={this.handleSwitchChange}
              checked={this.state.onExit}
              inputProps={{ 'aria-labelledby': 'switch-list-label-bluetooth' }}
            />} />
        </Tile>

            { /* Temporarily disabled
        <Tile
          title="Devices"
          subtitle="Select devices that will use this geofence.">
          {this.renderDeviceRows()}
        </Tile>
            */ }

        <Button loading={this.state.loading} onClick={this.handleSubmit} color="primary">Save</Button>

        {this.isGeofencePersisted() ? (
          <Button loading={this.state.loading} onClick={this.handleDelete} color="danger" classes={{ button: 'mt-1' }}>Delete</Button>
        ) : null}
      </div>
    );
  }
}

GeofenceEditorPanel.propTypes = {
  geofence: PropTypes.object,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
};

export default GeofenceEditorPanel;
